theme.initSlideShowHome  =  function(){
 var swiper = new Swiper('.lightSlider-shop', {
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.chevron-right',
      prevEl: '.chevron-left',
    },
    a11y: false,
    on: {
      init: function () {
        this.slides.forEach(function (slide) {
          slide.removeAttribute('role');
          slide.removeAttribute('aria-label');
          if (slide.tagName === 'A') {
            var slideText = slide.textContent.trim() || slide.getAttribute('href');
            slide.setAttribute('aria-label', slideText);
          }
        });
        // Manually add aria labels to navigation
        var nextBtn = document.querySelector('.chevron-right');
        var prevBtn = document.querySelector('.chevron-left');
        if (nextBtn) nextBtn.setAttribute('aria-label', 'Next slide');
        if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous slide');
      },
    },
    breakpoints: {
      1200: {
        slidesPerView: 6.5,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 20
      },
      320: {
        slidesPerView: 2.5,
        spaceBetween: 20
      }
    }
});
  
 var swiper = new Swiper(".postalSwiper", {
    slidesPerView: 5,
    spaceBetween: 5,
    
    // Fix infinite tab loop
    watchSlidesProgress: true,
    slideToClickedSlide: false,
    keyboard: {
        enabled: false,  // Disable Swiper's keyboard trap
    },
    a11y: {
        enabled: false,  // Disable accessibility module that causes tab looping
    },
    
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        1440: {
            slidesPerView: 5,
            spaceBetween: 5,
        },
        1200: {
            loop: true,
            slidesPerView: 4.5,
            spaceBetween: 5,
        },
        768: {
            loop: true,
            slidesPerView: 3.5,
            spaceBetween: 5,
        },
        580: {
            loop: true,
            slidesPerView: 2.5,
            spaceBetween: 5,
        },
        300: {
            loop: true,
            slidesPerView: 1.5,
            spaceBetween: 5,
        },
    },
});

 $('.proudly_certified_logo').on('init reInit', function() {
  $(this).find('.slick-track').attr('aria-label', 'Client certifications');
  $(this).find('.slick-track').attr('role', 'list');
  $(this).find('.slick-slide').attr('role', 'listitem');

  // ✅ Since there are no <a> tags, make the images focusable directly
  $(this).find('.slick-slide:not(.slick-cloned) .logo-bar-image img').each(function() {
    $(this).attr('tabindex', '0');
    $(this).attr('role', 'img');
    // alt is already set so screen readers will announce it
  });

  // ✅ Cloned slides — never focusable
  $(this).find('.slick-cloned .logo-bar-image img').attr('tabindex', '-1');
  $(this).find('.slick-cloned .logo-bar-image img').attr('aria-hidden', 'true');

  // ✅ Remove tabindex from slide wrapper divs
  $(this).find('.slick-slide').removeAttr('tabindex');

}).slick({
  dots: false,
  arrows: false,
  autoplay: true,
  infinite: true,
  speed: 200,
  slidesToShow: 6,
  slidesToScroll: 1,
  accessibility: false, // ✅ Stop Slick managing tabindex
  responsive: [
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1 
      }
    }
  ]
});

}
theme.collectiontabs =  function(){
 $('.tabs-main').each(function(){
    $(this).find(".tab_content").hide();
    $(this).find(".tab_content:first").show();
    if($(this).hasClass('tabs-left')){
      // Tab Left
      var tabHeight;
      tabHeight = $(this).find(' ul.tabs').height();
      $(this).find('.tab_container').css('min-height', tabHeight + 10 );
    }
  });
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var $parent = $(this).parents('.tabs-main');
    $parent.find(".tab_content").hide();
    var activeTab = $(this).attr("rel"); 
    $parent.find('.tab_container').find("#"+activeTab).fadeIn();		
    $(this).parent().find("li").removeClass("active");
    $(this).addClass("active");
    $parent.find(".tab_drawer_heading").removeClass("d_active");
    $parent.find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var $parent = $(this).parents('.tabs-main');
    $parent.find(".tab_content").slideUp();
    var d_activeTab = $(this).attr("rel"); 
    $parent.find("#"+d_activeTab).slideDown();
    $parent.find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
    $parent.find("ul.tabs li").removeClass("active");
    $parent.find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    $('html, body').animate({ scrollTop: $parent.find('.tab_container').position().top -100},500);
  });
}
$(function(){
  theme.collectiontabs();
 theme.initSlideShowHome();
});